<template>
  <!-- Definitions are sourced from Wiktionary; every definition screen carries the
       CC BY-SA attribution, matching the About page. Link text stays inline (the
       same pattern as SettingsStaticContent / ContentPage). -->
  <div class="def-attrib" data-testid="word-definition-attribution">
    <p class="def-attrib-src">
      Definitions from
      <a href="https://en.wiktionary.org/" target="_blank" rel="noopener noreferrer">Wiktionary</a>,
      licensed under
      <a
        href="https://creativecommons.org/licenses/by-sa/4.0/"
        target="_blank"
        rel="noopener noreferrer"
        >CC BY-SA 4.0</a
      >.
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.def-attrib {
  margin-top: 0.875rem;
  padding-top: 0.875rem;
  border-top: 1px solid var(--color-arena-border);
}

.def-attrib-src {
  margin: 0;
  text-align: center;
  font-family: var(--font-sans);
  font-size: 0.65625rem;
  line-height: 1.5;
  color: var(--color-arena-text-muted);
}

.def-attrib-src a {
  color: var(--color-arena-text-dim);
  text-decoration: none;
  border-bottom: 1px solid rgba(201, 168, 76, 0.4);
}

.def-attrib-src a:hover,
.def-attrib-src a:focus-visible {
  color: var(--color-energy-primary);
  border-bottom-color: var(--color-energy-primary);
}
</style>
